import { getZendeskLocale } from "@faire/web/common/zendesk/utils";
import { browserLevelLanguage } from "../serialized-data/getLocale";
export var localeString = getZendeskLocale(browserLevelLanguage());